import ProcedimentosSaude from '@/views/public/procedimentos_saude'
import ProcedimentosPorEspecialidade from '@/views/public/procedimentos_saude/PorEspecialidade'
import ProcedimentosPorExame from '@/views/public/procedimentos_saude/PorExame'
import ProcedimentosPorCartao from '@/views/public/procedimentos_saude/PorCartaoSUS'
import { DEFAULT_TITLE } from '../const'

export const procedimentosSaude = [
  {
    path: '/minhasaude',
    name: 'procedimentos_saude',
    component: ProcedimentosSaude,
    meta: {
      title: `${DEFAULT_TITLE} | Minha Saúde`
    }
  },
  {
    path: '/minhasaude/por-especialidade/:especialidade',
    name: 'procedimentos_por_especialidade',
    component: ProcedimentosPorEspecialidade,
    meta: {
      title: `${DEFAULT_TITLE} | Lista por Especialidade`
    }
  },
  {
    path: '/minhasaude/por-exame/:exame',
    name: 'procedimentos_por_exame',
    component: ProcedimentosPorExame,
    meta: {
      title: `${DEFAULT_TITLE} | Lista por Exame`
    }
  },
  {
    path: '/minhasaude/por-cartao/:cartao',
    name: 'procedimentos_por_cartao',
    component: ProcedimentosPorCartao,
    meta: {
      title: `${DEFAULT_TITLE} | Meu Cartão SUS`
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/public/procedimentosSaude.js